export default function(amount) {
    if (!amount && amount !== 0) {
        return '';
    } else if (amount == 0) {
        return "0"
    } else {
        return amount.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")
    }
}